__turbopack_context__.v({
  "className": "carmatitlefont_a200172c-module__Chjmpq__className",
  "variable": "carmatitlefont_a200172c-module__Chjmpq__variable",
});
